import React from 'react';
import sitemasterLogo from "../../../assets/SiteMaster.svg";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  Divider
} from '@mui/material';

const ViewTicketModal = ({ open, onClose, ticket }) => {
  if (!ticket) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    try {
      return new Date(dateStr).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: '2-digit',
      });
    } catch (e) {
      return '—';
    }
  };

  const title = ticket.title || ticket.issue_header || 'Issue title';
  const ticketId = ticket.ticketId || ticket.ticket_id || `#TICKET-${ticket.id}`;
  // const displayDate = formatDate(ticket.date || ticket.created_at);
  const createdAt = formatDate(ticket.created_at);
  const respondedOn = formatDate(ticket.modified_on);
  const resolutionBy = formatDate(ticket.resolution_by);

  const description = ticket.issue_description || '—';
  const fileAttachment = ticket.attachment;
  const fileName = fileAttachment ? fileAttachment.split('/').pop().split('?')[0] : '—';
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 3, overflowY: 'visible' } }}
    >
      {/* Header */}
      <Box
        sx={{
          background: 'linear-gradient(to bottom, #6C2BD7, #4C1E9B, #3B0069)',
          py: 3,
          textAlign: 'center',
          color: '#fff',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={sitemasterLogo} alt="SiteMaster Logo" style={{
            height: 32, marginBottom: 4,
            filter: 'brightness(0) invert(1)',
          }} />
        </Box>
        <Typography fontSize={14}
          sx={{
            fontFamily: 'Outfit, sans-serif'
          }}>
          Customer support
        </Typography>
      </Box>

      {/* Main content box */}
      <DialogContent>
        <Box
          sx={{
            backgroundColor: '#f3f2f5',
            p: 3,
            borderRadius: 3,
            mt: -3,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',

          }}
        >
          {/* Issue title & meta */}
          <Typography fontWeight={600} fontSize={15} sx={{
            fontFamily: 'Outfit, sans-serif'
          }}>
            {title}
          </Typography>
          <Typography fontSize={13} color="text.secondary" sx={{ mt: 0.5, fontFamily: 'Outfit, sans-serif' }}>
            Ticket id – <strong>{ticketId}</strong>
          </Typography>
          <Typography fontSize={13} color="text.secondary" sx={{ mb: 2, fontFamily: 'Outfit, sans-serif' }}>
            Issue raised on – {ticket.createdAt}
          </Typography>

          {/* Timeline with status */}
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              px: 3,
              pt: 2,
              pb: 3,
            }}
          >
            {/* Horizontal line*/}
            <Box
              sx={{
                position: 'absolute',
                top: 65,
                left: 45,
                right: 45,
                height: 2,
                backgroundColor: '#3B0069',
                zIndex: 0,
              }}
            />

            <Box textAlign="center" sx={{ zIndex: 1 }}>
              <Typography fontSize={12} fontWeight={500} sx={{ fontFamily: 'Outfit, sans-serif' }}>
                Request received
              </Typography>
              <Typography
                fontSize={13}
                fontWeight={500}
                color="#3B0069"
                sx={{ mb: 0.5, position: 'relative', zIndex: 1, fontFamily: 'Outfit, sans-serif' }}
              >
                {ticket.createdAt || '12 Feb 25'}
              </Typography>
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  backgroundColor: '#3B0069',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: 'auto',
                }}
              >
                <Typography fontSize={12} color="white">
                  ✓
                </Typography>
              </Box>
            </Box>

            <Box textAlign="center" sx={{ zIndex: 1 }}>
              <Typography fontSize={12} fontWeight={500} sx={{ fontFamily: 'Outfit, sans-serif' }}>
                Responded on
              </Typography>
              <Typography
                fontSize={13}
                fontWeight={500}
                color="#3B0069"
                sx={{ mb: 0.5, position: 'relative', zIndex: 1, fontFamily: 'Outfit, sans-serif' }}
              >
                {ticket.respondedOn || '—'}
              </Typography>
              {respondedOn ? (
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    backgroundColor: '#3B0069',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: 'auto',
                  }}
                >
                  <Typography fontSize={12} color="white">
                    ✓
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    border: '2px solid #3B0069',
                    borderRadius: '50%',
                    margin: 'auto',
                  }}
                />
              )}
            </Box>

            <Box textAlign="center" sx={{ zIndex: 1 }}>
              <Typography fontSize={12} fontWeight={500} sx={{ fontFamily: 'Outfit, sans-serif' }}>
                Resolution by
              </Typography>
              <Typography
                fontSize={13}
                fontWeight={500}
                color="#3B0069"
                sx={{ mb: 0.5, position: 'relative', zIndex: 1, fontFamily: 'Outfit, sans-serif' }}
              >
                {resolutionBy || '—'}
              </Typography>

              <Box
                sx={{
                  width: 20,
                  height: 20,
                  border: '2px solid #3B0069',
                  borderRadius: '50%',
                  position: 'relative',
                  margin: 'auto',
                }}
              >
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    backgroundColor: '#3B0069',
                    borderRadius: '50%',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                />
              </Box>
            </Box>
          </Box>


          {/* Duration Info */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 3 }}>
            <Box textAlign="center">
              <Typography fontSize={12} color="text.secondary">
                Response time
              </Typography>
              <Typography fontWeight={600}>2 Days</Typography>
            </Box>
            <Box textAlign="center">
              <Typography fontSize={12} color="text.secondary">
                Expected resolution time
              </Typography>
              <Typography fontWeight={600}>10 Days</Typography>
            </Box>
          </Box>
        </Box>

        {/* Description */}
        <Box sx={{ mt: 4 }}>
          <Typography fontWeight={600} fontSize={14} mb={1} sx={{ fontFamily: 'Outfit, sans-serif' }}>
            Issue description
          </Typography>
          <Typography fontSize={13} color="text.secondary" sx={{ fontFamily: 'Outfit, sans-serif' }}>
            {description}
          </Typography>
        </Box>

        {/* Uploads */}
        <Box sx={{ mt: 3 }}>
          <Typography fontWeight={600} fontSize={14} mb={1} sx={{ fontFamily: 'Outfit, sans-serif' }}>
            Uploads
          </Typography>
          {fileAttachment ? (
            <Chip
              label={fileName}
              component="a"
              href={fileAttachment}
              target="_blank"
              clickable
              sx={{ mr: 1 }}
            />
          ) : (
            <Chip label="No attachment" />
          )}


        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: 999,
            color: "#3B0069",
            borderColor: "#3B0069",
            '&:hover': {
              borderColor: "#3B0069",
              backgroundColor: '#f3e9ff',
            }
          }}
        >
          Close
        </Button>

      </DialogActions>
    </Dialog>
  );
};

export default ViewTicketModal;
